import { GridProps } from '@mui/material';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataGridElement,
  DataGridElementProps,
  DataGridElementType
} from '../../../../lib/components/compound/dataGrid';

interface Props<T extends object> extends Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'> {
  data: T;
  field: keyof T;
  type?: DataGridElementProps['type'];
  title?: string;
  renderValue?: (value: T[keyof T]) => DataGridElementProps['value'];
}

export const EmployeeDataGridElement: <T extends object>(
  props: PropsWithChildren<Props<T>>
) => DataGridElementType = ({
  data,
  field,
  type,
  title,
  renderValue = (value) => {
    return value ? String(value) : undefined;
  },
  ...gridSizes
}) => {
  const { t } = useTranslation();
  const isFieldMissing =
    Object.hasOwn(data, 'missing_fields') &&
    (data as { missing_fields?: string[] })?.missing_fields?.includes(field.toString());
  const value = data[field];

  return (
    <DataGridElement
      {...gridSizes}
      type={type}
      title={title ?? t(`employee_props:${field.toString()}`)}
      value={renderValue(value)}
      required={isFieldMissing}
      missingMessage={t('employee:MISSING_FOR_COMPLETENESS')}
    />
  ) as DataGridElementType;
};

export type EmployeeDataGridElementType<T extends object> = React.ReactElement<
  PropsWithChildren<Props<T>>
>;
